<template>
    <div class="main-wrapper">
        <layout-header />

        <div class="content container">
            <div class="d-flex justify-content-around align-items-top py-4">
                <div class="mt-3 text-center w-100" style="max-width: 33%;">
                    <figure class="bg-white rounded-xl mb-2 border mx-auto" style="width: fit-content;">
                        <a :href="'/team/'+match?.team_a?.id" class="d-block p-3">
                            <img :src="match?.team_a?.logo || defaultTeamLogoPath" width="60px" class="h-auto">
                        </a>
                    </figure>
                    <span class="d-block mb-3">{{ match.team_a?.name }}</span>
                </div>
                <div class="mx-2 d-flex flex-column justify-content-start align-items-center">
                    <span class="text-muted text-center mb-3">{{ formatDateTime(match.starts_at).datetime }}</span>
                    <span class="font-weight-bold">
                        <span class="h1">{{ match.score_a ?? 0 }}</span>
                        <b class="h1 mx-1">-</b>
                        <span class="h1">{{ match.score_b ?? 0 }}</span>
                    </span>
                    <div v-if="showLiveMinute" class="live-minute-badge my-3">{{ liveMinute }}'</div>
                    <!-- Set match status -->
                    <div v-else class="d-flex align-items-center mt-2">
                        <span class="badge badge-pill text-xs py-1 px-2" 
                            :class="match.status === 'draft' ? 'bg-secondary-light'
                            : match.status === 'scheduled' ? 'bg-info-light'
                            : match.status === 'completed' ? 'bg-success-light'
                            : match.status === 'cancelled' ? 'bg-danger-light'
                            : 'bg-warning-light'"
                        >
                            {{ statuses[match.status]?.label }}
                        </span>
                    </div>
                </div>
                <div class="mt-3 text-center w-100" style="max-width: 33%;">
                    <figure class="bg-white rounded-xl mb-2 border mx-auto" style="width: fit-content;">
                        <a :href="'/team/'+match?.team_b?.id" class="d-block p-3">
                            <img :src="match.team_b?.logo || defaultTeamLogoPath" width="60px" class="h-auto">
                        </a>
                    </figure>
                    <span class="d-block mb-3">{{ match.team_b?.name }}</span>
                </div>
            </div>

            <div class="tab-content mb-5 pb-3">
                <ul class="nav nav-tabs nav-tabs-bottom nav-justified mb-4" style="border-bottom: 1px solid #dee2e6">
                    <li class="nav-item">
                        <a class="nav-link" :class="{ active: activeTab === 'summary' }"
                            @click="this.activeTab='summary'" href="javascript:void(0)">Resumé</a>
                    </li>
                    <li class="nav-item">
                        <a class="nav-link" :class="{ active: activeTab === 'general' }"
                            @click="this.activeTab='general'" href="javascript:void(0)">Informations</a>
                    </li>
                    <li class="nav-item">
                        <a class="nav-link" :class="{ active: activeTab === 'formation' }"
                            @click="this.activeTab='formation'" href="javascript:void(0)">Compositions</a>
                    </li>
                    <li class="nav-item">
                        <a class="nav-link" :class="{ active: activeTab === 'h2h' }"
                            @click="this.activeTab='h2h'" href="javascript:void(0)">Tête-à-tête</a>
                    </li>
                </ul>
                <div v-if="activeTab === 'summary'" class="tab-pane fade show active">
                    <div>
                        <div v-if="orderedMatchActions.length === 0" class="text-center text-sm text-muted py-4">Aucune action.</div>
                        <div v-else class="border rounded-lg bg-white px-3 py-2">
                            <div
                                v-for="item in orderedMatchActions"
                                :key="item.id"
                                class="summary-event border-bottom py-2"
                                :class="item.team_id === match.team_b_id ? 'summary-event-right' : 'summary-event-left'"
                            >
                                <div class="summary-event-minute text-muted text-xs">{{ item.minute ? `${item.minute}'` : '-' }}</div>
                                <div class="summary-event-marker">
                                    <span class="action-marker" :class="actionTypeTone(item.action_type)">
                                        <span class="material-symbols-outlined action-marker-icon">{{ actionTypeIcon(item.action_type) }}</span>
                                    </span>
                                </div>
                                <div class="summary-event-copy">
                                    <div class="text-sm font-weight-medium">{{ actionTypeLabel(item.action_type) }}</div>
                                    <div class="text-xs text-muted">{{ item.player?.name || '-' }}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div v-if="activeTab === 'general'" class="tab-pane fade show active">
                    <table class="table table-striped table-borderless text-sm">
                        <tbody>
                            <tr>
                                <td>
                                    <div class="d-flex align-items-center">
                                        <span class="material-symbols-outlined font-size-1 mr-2">stadium</span>
                                        Terrain
                                    </div>
                                </td>
                                <td class="text-right">
                                    <b>Terrain {{ match.facility?.name }}</b>
                                    <span class="ml-1">({{ match.facility?.establishment.business_name }})</span>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <div class="d-flex align-items-center">
                                        <span class="material-symbols-outlined font-size-1 mr-2">location_on</span>
                                        Adresse
                                    </div>
                                </td>
                                <td class="text-right">
                                    {{ match.facility?.establishment.delegation }}
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <div class="d-flex align-items-center">
                                        <span class="material-symbols-outlined font-size-1 mr-2">groups</span>
                                        Capacité
                                    </div>
                                </td>
                                <!-- <td class="text-right font-weight-bold" v-if="notStartedYet(match) && currentUser.id === match.booking.user_id">
                                    {{ match.booking?.slot.facility.capacity / 2 }}v{{ match.booking?.slot.facility.capacity / 2 }}
                                    <select class="custom-select custom-select-sm" v-model="">
                                        <option></option>
                                    </select>
                                </td> -->
                                <td class="text-right font-weight-bold">
                                    <span v-if="matchCapacitySlots">{{ matchCapacitySlots }}v{{ matchCapacitySlots }}</span>
                                    <span v-else>-</span>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div v-if="activeTab === 'formation'" class="tab-pane fade show active">
                    <!--<div v-if="!matchCapacitySlots" class="alert alert-light border text-sm">
                        Les détails terrain/capacité ne sont pas encore disponibles pour ce défi.
                    </div>
                    <table class="table table-striped table-borderless text-sm">
                        <thead class="thead-light">
                            <tr>
                                <th class="w-25 align-middle-important">
                                    <span>{{ match.team_a_formation }}</span>
                                </th>
                                <th class="text-center align-middle-important">Formation</th>
                                <th class="w-25 text-right align-middle-important">
                                    <span>{{ match.team_b_formation }}</span>
                                </th>
                            </tr>
                        </thead>
                    </table>
                    <div class="bg-light rounded-lg p-2 my-2">
                        <div class="bg-cover d-flex justify-content-between mx-auto my-2" style="max-width: 500px; width:100%; aspect-ratio: 3 / 2;" :style="'background-position: center;background-image: url('+require('@/assets/img/pitch.png')+');'">
                            <div class="w-50 h-100 d-block py-3 pl-3">
                                <div class="w-100 h-100 d-flex" v-if="match.team_a_formation != ''">
                                    <div class="w-25 h-100 d-flex flex-column justify-content-around" v-for="(total, index) in ('1-'+match.team_a_formation).split('-')">
                                        <span class="bg-white rounded-sm shadow" style="height: fit-content;width: fit-content;" v-for="pos in parseInt(total)">
                                            <span class="badge p-2" :class="startingPositions[formationPositions[index]]['class']" style="min-width: 34px;height: fit-content;">
                                                {{ startingPositions[formationPositions[index]]['abbr'] }}
                                            </span>
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <div class="w-50 h-100 d-block py-3 pl-3">
                                <div class="w-100 h-100 d-flex" v-if="match.team_b_formation">
                                    <div class="w-25 h-100 d-flex flex-column justify-content-around" v-for="(total, index) in ('1-'+match.team_b_formation).split('-').reverse()">
                                        <span class="bg-white rounded-sm shadow" style="height: fit-content;width: fit-content;" v-for="pos in parseInt(total)">
                                            <span class="badge p-2" :class="startingPositions[formationPositions[formationPositions.length-index-1]]['class']" style="min-width: 34px;height: fit-content;">
                                                {{ startingPositions[formationPositions[formationPositions.length-index-1]]['abbr'] }}
                                            </span>
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>-->
                    <table class="table table-striped table-borderless text-sm">
                        <thead class="thead-light">
                            <tr>
                                <th colspan="3" class="text-center">Titulaires</th>
                            </tr>
                        </thead>
                        <tbody class="text-xs">
                            <template v-for="index in starterRowsCount" :key="index">
                                <tr>
                                    <td colspan="2" class="w-50" style="vertical-align: middle;">
                                        <span class="d-flex align-items-center" v-if="startingTeamA[index - 1]">
                                            <span class="badge p-1 py-2 mr-2" v-if="startingTeamA[index - 1].position" :class="startingPositions[startingTeamA[index - 1].position]['class']" style="min-width: 25px;">
                                                {{ startingPositions[startingTeamA[index - 1].position]['abbr'] }}
                                            </span>
                                            <span class="d-flex align-items-center" v-if="startingTeamA[index - 1].player_name">
                                                <span>
                                                    {{ startingTeamA[index - 1].player_name }}
                                                    <b v-if="match.team_a?.captain_id == startingTeamA[index - 1].player_id">(C)</b>
                                                </span>
                                            </span>
                                            <span v-else>Poste non attribué</span>
                                        </span>
                                    </td>
                                    <td class="w-50 text-right" style="vertical-align: middle;">
                                        <span class="d-flex align-items-center justify-content-end" v-if="startingTeamB[index - 1]">
                                            <span class="d-flex align-items-center" v-if="startingTeamB[index - 1].player_name">
                                                <span>
                                                    <b v-if="match.team_b?.captain_id == startingTeamB[index - 1].player_id">(C)</b>
                                                    {{ startingTeamB[index - 1].player_name }}
                                                </span>
                                            </span>
                                            <span v-else>Poste non attribué</span>
                                            <span class="badge p-1 py-2 ml-2" v-if="startingTeamB[index - 1].position" :class="startingPositions[startingTeamB[index - 1].position]['class']" style="min-width: 25px;">
                                                {{ startingPositions[startingTeamB[index - 1].position]['abbr'] }}
                                            </span>
                                        </span>
                                    </td>
                                </tr>
                            </template>
                        </tbody>
                    </table>
                </div>
                <div v-if="activeTab === 'h2h'" class="tab-pane fade show active">
                    <div class="text-center text-sm">
                        Aucun match.
                    </div>
                </div>
            </div>


        </div>

        <layout-footer />
    </div>
</template>
<script>
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import moment from "moment";
import 'moment/locale/fr';
import { api } from "@/store";
import CustomerSidebar from "@/components/Customers/Partials/Sidebar";
import defaultTeamLogoPath from '@/assets/img/default-team-logo.png'

export default {
    computed: {
        liveBooking() {
            return this.match.booking || (this.match.starts_at ? { start_time: this.match.starts_at, end_time: this.match.ends_at || null } : null)
        },
        liveMinute() {
            const booking = this.liveBooking
            if (!booking?.start_time || !booking?.end_time) return null

            const now = new Date(this.now)
            const start = new Date(booking.start_time)
            const end = new Date(booking.end_time)

            if (Number.isNaN(now.getTime()) || Number.isNaN(start.getTime()) || Number.isNaN(end.getTime())) return null
            if (now < start || now > end) return null

            const minute = Math.floor((now - start) / 60000) + 1
            return minute > 0 ? minute : 1
        },
        showLiveMinute() {
            return this.liveMinute !== null
        },
        orderedMatchActions() {
            return [...(this.match.actions || [])].sort((a, b) => (a.minute || 0) - (b.minute || 0));
        },
        startingTeamA() {
            return this.getVisibleStarters(
                this.match.team_a,
                this.match.team_a_formation,
                this.match.team_a_id
            );
        },
        startingTeamB() {
            return this.getVisibleStarters(
                this.match.team_b,
                this.match.team_b_formation,
                this.match.team_b_id
            );
        },
        matchCapacitySlots() {
            return this.getMatchCapacity(this.match) || 0;
        },
        starterRowsCount() {
            return Math.max(
                this.matchCapacitySlots || 0,
                this.startingTeamA.length,
                this.startingTeamB.length,
                1
            )
        },
    },
    props: ['id'],
    data() {
        return {
            activeTab: 'summary',
            now: Date.now(),
            liveTimer: null,
            defaultTeamLogoPath: defaultTeamLogoPath,
            match: {
                team_a: null,
                team_b: null,
                team_a_formation: null,
                team_b_formation: null,
                lineups: [],
                suggestions: []
            },
            player: {},
            formationPositions: ['goalkeeper','defender', 'midfielder', 'forward'],
            defaultLineup: {
                id: null,
                match_id: this.id,
                team_id: null,
                player_id: null,
                player_name: '',
                is_guest: false,
                position: null,
                role: 'substitute',
                status: 'confirmed'
            },
            teams: [],
            myTeams: [],
            opponentTeams: [],
            membershipRoles: {
                'captain': 'Capitaine',
                'starting': 'Titulaire',
                'substitute': 'Remplaçant'
            },
            statuses: {
                'challenged': {'label': 'défi en cours', 'class': 'bg-primary'},
                'scheduled': {'label': 'à venir', 'class': 'bg-primary-light'},
                'completed': {'label': 'terminé', 'class': 'bg-success-light'},
                'cancelled': {'label': 'annulé', 'class': 'bg-danger text-white'},
                'unfinished': {'label': 'inachevé', 'class': 'bg-danger-light'},
            },
            challengeStatuses: {
                'pending': {'label': 'en attente', 'class': 'bg-warning-light'},
                'countered': {'label': 'contre-proposé', 'class': 'bg-info-light'},
                'accepted': {'label': 'accepté', 'class': 'bg-success-light'},
                'declined': {'label': 'rejeté', 'class': 'bg-danger-light'},
                'cancelled': {'label': 'annulé', 'class': 'bg-danger-light'},
            },
            startingPositions: {
                'goalkeeper': {'abbr': 'G', 'class': 'bg-warning-light'},
                'defender': {'abbr': 'DF', 'class': 'bg-primary-light'},
                'midfielder': {'abbr': 'ML', 'class': 'bg-success-light'},
                'forward': {'abbr': 'AT', 'class': 'bg-danger-light'}
            },
            selectedStarting: {},
            selectedIndex: null,
        }
    },
    mounted() {
        this.getMatch()
        this.startLiveClock()
    },
    beforeUnmount() {
        if (this.liveTimer) {
            clearInterval(this.liveTimer)
            this.liveTimer = null
        }
    },
    methods: {
        startLiveClock() {
            this.now = Date.now()
            if (this.liveTimer) {
                clearInterval(this.liveTimer)
            }
            this.liveTimer = setInterval(() => {
                this.now = Date.now()
            }, 15000)
        },
        getMatch() {
            api.get(`/match/${this.id}`).then(res => {
                let match = res.data;
                match.team_a_formation ||= match.team_a?.formation || null
                match.team_b_formation ||= match.team_b?.formation || null
                let team_a_lineups = match.lineups.filter(l => l.team_id === match.team_a_id)
                let team_b_lineups = match.lineups.filter(l => l.team_id === match.team_b_id)
                // INIT FULL LINEUP ONLY ONCE
                if (!match.lineups || !match.lineups.length) {
                    match.lineups = [
                        ...this.initTeamLineup(match.team_a, match.team_a_formation),
                        ...this.initTeamLineup(match.team_b, match.team_b_formation)
                    ];
                }
                if (this.lineupToInit(team_a_lineups)) {
                    team_a_lineups = this.initTeamLineup(match.team_a, match.team_a_formation, team_a_lineups)
                }
                if (this.lineupToInit(team_b_lineups)) {
                    team_b_lineups = this.initTeamLineup(match.team_b, match.team_b_formation, team_b_lineups)
                }
                match.lineups = [ ...team_a_lineups, ...team_b_lineups]
                if (match.status === 'scheduled' && !this.notStartedYet(match)) {
                    match.status = 'completed'
                }
                this.match = match
            });
        },
        notStartedYet(match) {
            return this.formatDateTime(match.starts_at).datetime > moment().format('YYYY-MM-DD HH:mm')
        },
        getMatchCapacity(match) {
            const capacity = match.facility?.capacity
            if (!capacity) return null
            return capacity / 2
        },
        initTeamLineup(team, formation, team_guests = []) {
            if (!team || !formation) return [];
            const slots = this.buildFormationMap(formation);
            const orderedPositions = this.formationPositions;
            // accepted members only
            let members = team.memberships
                .filter(m => m.status === 'accepted')
                .map(m => ({
                    id: null,
                    match_id: this.id,
                    team_id: team.id,
                    player_id: m.player_id,
                    player_name: m.player.name,
                    is_guest: false,
                    role: m.role === 'starting' ? 'starting' : 'substitute',
                    position: m.lineup_position || null,
                    status: 'confirmed'
                }));

            members = [...members, ...team_guests]

            const starters = [];
            const used = new Set();

            /* ----------------------------------------
            * 1. Place membership starters first
            * ---------------------------------------- */
            orderedPositions.forEach(position => {
                const max = slots[position] || 0;
                if (!max) return;
                const candidates = members.filter(
                    m => m.role === 'starting' && m.position === position && !used.has(m.player_id)
                );
                candidates.slice(0, max).forEach(p => {
                    starters.push(p);
                    used.add(p.player_id);
                });
            });

            /* ----------------------------------------
            * 2. Fill remaining slots with starters (wrong position)
            * ---------------------------------------- */
            orderedPositions.forEach(position => {
                const filled = starters.filter(s => s.position === position).length;
                const remaining = (slots[position] || 0) - filled;
                if (remaining <= 0) return;
                const candidates = members.filter(m => m.role === 'starting' && !used.has(m.player_id));
                candidates.slice(0, remaining).forEach(p => {
                    p.position = position;
                    starters.push(p);
                    used.add(p.player_id);
                });
            });

            /* ----------------------------------------
            * 3. Fill with substitutes if still needed
            * ---------------------------------------- */
            orderedPositions.forEach(position => {
                const filled = starters.filter(s => s.position === position).length;
                const remaining = (slots[position] || 0) - filled;
                if (remaining <= 0) return;
                const candidates = members.filter(m => m.role === 'substitute' && !used.has(m.player_id));

                candidates.slice(0, remaining).forEach(p => {
                    p.role = 'starting';
                    p.position = position;
                    starters.push(p);
                    used.add(p.player_id);
                });
            });

            /* ----------------------------------------
            * 4. Demote overflow starters
            * ---------------------------------------- */
            members.forEach(m => {
                if (m.role === 'starting' && !used.has(m.player_id)) {
                    m.role = 'substitute';
                    m.position = null;
                }
            });

            return members;
        },
        /* ===================================================
        * FORMATION & DERIVED LINEUPS
        * =================================================== */
        getStartingLineup(team, formation) {
            if (!team || !formation) return [];
            const formationMap = this.buildFormationMap(formation);
            const starters = this.match.lineups.filter(
                l => l.team_id === team.id && l.role === 'starting'
            );
            const result = [];
            this.formationPositions.forEach(pos => {
                const needed = formationMap[pos];
                const players = starters.filter(p => p.position === pos);

                for (let i = 0; i < needed; i++) {
                    result.push(
                        players[i] || {
                            ...this.defaultLineup,
                            match_id: this.id,
                            team_id: team.id,
                            position: pos
                        }
                    );
                }
            });
            return result;
        },
        getVisibleStarters(team, formation, teamId) {
            const byFormation = this.getStartingLineup(team, formation)
            const hasNamedPlayers = byFormation.some(p => p?.player_name || p?.player_id)
            if (hasNamedPlayers) return byFormation
            const starters = this.getTeamStarters(team?.id || teamId)
            if (starters.length) return starters
            return this.getTeamAcceptedMembers(team)
        },
        getTeamStarters(teamId) {
            if (!teamId || !Array.isArray(this.match?.lineups)) return []
            const teamLineups = this.match.lineups.filter(l => l.team_id === teamId)
            const starters = teamLineups.filter(l => l.role === 'starting')
            const source = starters.length ? starters : teamLineups
            return source.sort((a, b) => {
                const aPos = this.formationPositions.indexOf(a.position)
                const bPos = this.formationPositions.indexOf(b.position)
                return (aPos === -1 ? 99 : aPos) - (bPos === -1 ? 99 : bPos)
            })
        },
        getTeamAcceptedMembers(team) {
            if (!team || !Array.isArray(team.memberships)) return []
            return team.memberships
                .filter(m => m.status === 'accepted')
                .filter(m => ['starting', 'captain'].includes(m.role))
                .map(m => ({
                    player_id: m.player_id,
                    player_name: m.player?.name || '',
                    position: m.lineup_position || null,
                    role: m.role,
                }))
                .sort((a, b) => {
                    const aPos = this.formationPositions.indexOf(a.position)
                    const bPos = this.formationPositions.indexOf(b.position)
                    return (aPos === -1 ? 99 : aPos) - (bPos === -1 ? 99 : bPos)
                })
        },
        buildFormationMap(formation) {
            const [d, m, f] = formation.split('-').map(Number);
            return {
                goalkeeper: 1,
                defender: d,
                midfielder: m,
                forward: f
            };
        },
        lineupToInit(lineup) {
            const lineupGuests = lineup.filter(l => l.is_guest)
            const lineupSubstitutes = lineup.filter(l => l.role === 'substitute')
            return lineupSubstitutes.length === lineup.length || lineupGuests.length === lineup.length
        },
        //==============================
        formatDateTime(datetimeString) {
            if (!datetimeString) return "";
            const date = new Date(datetimeString);
            const formattedDate = date.toISOString().split("T")[0];
            // Extract local hours and minutes
            const hours = date.getHours().toString().padStart(2, "0");
            const minutes = date.getMinutes().toString().padStart(2, "0");
            let date_obj = {
                date: formattedDate,
                time: `${hours}:${minutes}`,
                datetime: formattedDate + ` ${hours}:${minutes}`,
            };
            return date_obj;
        },
        actionTypeLabel(actionType) {
            if (actionType === 'goal') return 'But';
            if (actionType === 'yellow_card') return 'Carton jaune';
            if (actionType === 'red_card') return 'Carton rouge';
            return actionType || 'Action';
        },
        actionTypeIcon(actionType) {
            if (actionType === 'goal') return 'sports_soccer';
            if (actionType === 'yellow_card') return 'square';
            if (actionType === 'red_card') return 'square';
            return 'radio_button_unchecked';
        },
        actionTypeTone(actionType) {
            if (actionType === 'goal') return 'tone-goal';
            if (actionType === 'yellow_card') return 'tone-yellow';
            if (actionType === 'red_card') return 'tone-red';
            return 'tone-neutral';
        },
    }
}
</script>

<style scoped>
.action-marker {
    width: 22px;
    height: 22px;
    border-radius: 999px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    flex: 0 0 22px;
}

.action-marker-icon {
    font-size: 14px !important;
    line-height: 1;
}

.summary-event {
    display: flex;
    align-items: center;
    gap: 0.5rem;
}

.summary-event-left {
    flex-direction: row;
    text-align: left;
}

.summary-event-right {
    flex-direction: row-reverse;
    text-align: right;
}

.summary-event-minute {
    min-width: 42px;
    flex: 0 0 42px;
}

.summary-event-marker {
    flex: 0 0 22px;
}

.summary-event-copy {
    flex: 1 1 auto;
    min-width: 0;
}

.tone-goal {
    background: rgba(25, 135, 84, 0.12);
    color: #198754;
}

.tone-yellow {
    background: rgba(255, 193, 7, 0.16);
    color: #b58100;
}

.tone-red {
    background: rgba(220, 53, 69, 0.14);
    color: #dc3545;
}

.tone-neutral {
    background: rgba(108, 117, 125, 0.12);
    color: #6c757d;
}

.live-minute-badge {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding: 0.25rem 0.7rem;
    border-radius: 999px;
    color: #fff;
    font-weight: 700;
    font-size: 0.75rem;
    letter-spacing: 0.04em;
    background: #A61616;
    animation: livePulse 1.4s ease-in-out infinite;
}

@keyframes livePulse {
    0% {
        background: #A61616;
        box-shadow: 0 0 0 0 rgba(166, 22, 22, 0.35);
    }
    50% {
        background: #E63232;
        box-shadow: 0 0 12px 2px rgba(230, 50, 50, 0.45);
    }
    100% {
        background: #A61616;
        box-shadow: 0 0 0 0 rgba(166, 22, 22, 0.35);
    }
}
</style>